// extracted by mini-css-extract-plugin
export var avatar = "_np-3";
export var avatarContainer = "_np-2";
export var avatarSpacer = "_np-5";
export var avatarSpacerContainer = "_np-4";
export var avatarStackContainer = "_np-1";
export var bubble = "_np-0";
export var remainderBubble = "_np-6";